import React, { useState, useEffect, useRef } from 'react';

import { Link } from 'react-router-dom';
import { auth } from '../firebase';

import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import GamaAssistant from './GamaAssistant';
import SkillBuilder from './SkillBuilder';
import { FaBars, FaBell, FaBookOpen, FaBullseye, FaChartLine } from 'react-icons/fa6';
import { HiHome } from 'react-icons/hi';
import { FaCog, FaFileAlt, FaHome, FaSignOutAlt, FaTools } from 'react-icons/fa';

import { db } from '../firebase';
import { getDocs, collection } from 'firebase/firestore';

import { listUserModules } from "../services/modules";
import FocusLoader from '../components/FocusLoader';

const Dashboard = () => {
    const [userData, setUserData] = useState({
        name: "Ana Silva",
        role: "Desenvolvedora Front-end",
        progress: 65,
        modulesCompleted: 3,
        skills: ["React", "Comunicação", "Gestão de Tempo", "Inteligência Emocional"],
        emotionalState: {
            resilience: 78,
            empathy: 85,
            selfAwareness: 70,
            stressManagement: 65
        },
        careerGoals: ["Sênior em 2 anos", "Liderança técnica", "Palestrante"],
        learningPath: [
            { id: 1, name: "Orientação Profissional", progress: 100 },
            { id: 2, name: "Inteligência Emocional", progress: 85 },
            { id: 3, name: "Oratória", progress: 45 },
            { id: 4, name: "Desenvolvimento Pessoal", progress: 30 }
        ],
        recentAchievements: [
            { id: 1, title: "Certificado em Gestão Emocional", date: "15/06/2023" },
            { id: 2, title: "Palestra em evento da empresa", date: "05/06/2023" },
            { id: 3, title: "Feedback positivo de liderança", date: "28/05/2023" }
        ],
        notifications: [
            { id: 1, title: "Novo módulo disponível", content: "Liderança Inclusiva está disponível", read: false },
            { id: 2, title: "Atualização no currículo", content: "3 novas habilidades foram adicionadas", read: true },
            { id: 3, title: "Feedback recebido", content: "Seu colega deixou um feedback positivo", read: false }
        ]
    });
    const [loading, setLoading] = useState(false);
    const [modules, setModules] = useState([]);
    const [userModules, setUserModules] = useState([]);

    const [activeView, setActiveView] = useState('overview');
    const [assistantActive, setAssistantActive] = useState(true);
    const [assistantMessages, setAssistantMessages] = useState([
        { text: "Olá, Ana! Bem-vinda ao seu Dashboard de Autoconhecimento.", sender: 'bot' },
        { text: "Posso te guiar pelas suas métricas e conquistas. Por onde gostaria de começar?", sender: 'bot' }
    ]);


    const [sidebarOpen, setSidebarOpen] = useState(false); // Estado para menu mobile

    const navigate = useNavigate();
    const statsRef = useRef(null);
    const resumeRef = useRef(null);
    const goalsRef = useRef(null);

    // Efeito para o assistente explicar as seções quando elas são visualizadas
    useEffect(() => {
        const statsNode = statsRef.current;
        const resumeNode = resumeRef.current;
        const goalsNode = goalsRef.current;
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    let message = "";
                    switch (entry.target.id) {
                        case "stats-section":
                            message = "Esta é sua Análise Emocional. Vejo que sua empatia está muito desenvolvida!";
                            break;
                        case "resume-section":
                            message = "Seu Currículo Vivo reflete suas conquistas em tempo real. Impressionante como suas habilidades em React evoluíram!";
                            break;
                        case "goals-section":
                            message = "Seus objetivos estão bem alinhados com seu progresso. O caminho para liderança técnica parece promissor.";
                            break;
                        default:
                            return;
                    }

                    setAssistantMessages(prev => [
                        ...prev,
                        { text: message, sender: 'bot' }
                    ]);
                }
            });
        }, { threshold: 0.5 });

        if (statsNode) observer.observe(statsNode);
        if (resumeNode) observer.observe(resumeNode);
        if (goalsNode) observer.observe(goalsNode);

        return () => {
            if (statsNode) observer.unobserve(statsNode);
            if (resumeNode) observer.unobserve(resumeNode);
            if (goalsNode) observer.unobserve(goalsNode);
        };
    }, []);

    const handleLogout = async () => {
        // Lógica de logout
        try {
            await auth.signOut();
            navigate("/", { replace: true });
        } catch (err) {
            console.error("Erro ao deslogar:", err);
            alert("Ocorreu um erro ao sair. Tente novamente.");
        }
    };

    const toggleAssistant = () => {
        setAssistantActive(!assistantActive);
    };

    const addAssistantMessage = (message) => {
        setAssistantMessages(prev => [...prev, { text: message, sender: 'user' }]);

        // Simular resposta do bot após um curto período
        setTimeout(() => {
            setAssistantMessages(prev => [
                ...prev,
                { text: "Entendi. Posso te mostrar mais detalhes sobre essa métrica ou te sugerir conteúdos relacionados.", sender: 'bot' }
            ]);
        }, 1000);
    };

    // Função para fechar o menu quando clicar em um item (mobile)
    const handleNavClick = (view) => {
        setActiveView(view);
        setSidebarOpen(false);
    };

    useEffect(() => {
        listUserModules().then(setUserModules);
    }, []);

    useEffect(() => {
        async function fetchModules() {
            setLoading(true);
            try {
                const snap = await getDocs(collection(db, "modules"));
                const list = snap.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setModules(list);
                console.log("-------------Módulos carregados-------------");
                console.log(list);
                console.log("-------------Módulos Setados-------------");
                console.log(modules);
            } catch (err) {
                console.error("Erro ao carregar módulos:", err);
            } finally {
                setLoading(false);
            }
        }
        fetchModules();
    }, [modules]);



    const handleAdd = async () => {
        // Exemplo de criar um novo módulo com id único
        /*const newId = prompt("ID do novo módulo (ex: educacao_rendimento)");
        const novoModulo = {
            titulo: "Educação e Rendimento Escolar",
            descricao: "",
            topicos: []
        };*/
        //await saveModule(newId, novoModulo);
        setUserModules(await listUserModules());
    };



    function getInitials(fullName) {
        // 1. Remove espaços extras das extremidades
        const trimmed = fullName.trim();

        // Se, após trim, não tiver nada, retorna string vazia
        if (!trimmed) return '';

        // 2. Quebra por um ou mais espaços
        const parts = trimmed.split(/\s+/);

        // 3. Pega o primeiro e o último
        const firstName = parts[0];
        const lastName = parts[parts.length - 1];

        // 4. Extrai a primeira letra de cada
        const firstInitial = firstName.charAt(0).toUpperCase();
        const lastInitial = lastName.charAt(0).toUpperCase();

        return `${firstInitial}${lastInitial}`;
    }

    if (loading) return <FocusLoader />

    //TODO: Remover
    const any = false;
    if (any) {
        console.log(userModules)
        handleAdd();
        setUserData();
    }
    return (
        <div className="dashboard">
            {/* Sidebar */}
            <div className={`sidebar ${sidebarOpen ? 'active' : ''}`}>
                <div className="sidebar-header">
                    <div className="user-avatar">
                        <div className="avatar-initials">{getInitials(auth.currentUser.displayName)}</div>
                        <div className="online-status"></div>
                    </div>
                    <div className="user-info">
                        <h3>{auth.currentUser.displayName}</h3>
                        <p>{userData.role}</p>
                    </div>
                </div>

                <div className="progress-container">
                    <div className="progress-label">
                        <span>Jornada Completa</span>
                        <span>{userData.progress}%</span>
                    </div>
                    <div className="progress-bar">
                        <div
                            className="progress-fill"
                            style={{ width: `${userData.progress}%` }}
                        ></div>
                    </div>
                </div>

                <nav className="dashboard-nav">
                    <button
                        className={activeView === 'overview' ? 'active' : ''}
                        onClick={() => handleNavClick('overview')}
                    ><HiHome /> Visão Geral
                    </button>
                    <button
                        className={activeView === 'modules' ? 'active' : ''}
                        onClick={() => handleNavClick('modules')}
                    >
                        <FaBookOpen /> Meus Módulos
                    </button>
                    <button
                        className={activeView === 'resume' ? 'active' : ''}
                        onClick={() => handleNavClick('resume')}
                    >
                        <FaFileAlt />Currículo Vivo
                    </button>
                    <button
                        className={activeView === 'goals' ? 'active' : ''}
                        onClick={() => handleNavClick('goals')}
                    >
                        <FaBullseye />Metas e Objetivos
                    </button>
                    <button
                        className={activeView === 'analytics' ? 'active' : ''}
                        onClick={() => handleNavClick('analytics')}
                    ><FaChartLine />Análises
                    </button>
                    {/* Novo item para o Construtor de Habilidades */}
                    <button
                        className={activeView === 'skillBuilder' ? 'active' : ''}
                        onClick={() => handleNavClick('skillBuilder')}
                    ><FaTools />Construtor de Habilidades
                    </button>
                    <Link to={'/skillbuilder'}
                        className={activeView === 'skillBuilder' ? 'active' : ''}
                    >
                        <FaTools /> Construir Habilidade
                    </Link>
                </nav>

                <div className="sidebar-footer">
                    <button className="settings-btn">
                        <FaCog className="fas fa-cog" /> Configurações
                    </button>
                    <button className="logout-btn" onClick={handleLogout}>
                        <FaSignOutAlt className="fas fa-sign-out-alt" /> Sair
                    </button>

                </div>
            </div>

            {/* Main Content */}
            <div className="main-content">
                {/* Header */}
                <header className="dashboard-header">
                    <div className="header-left">
                        {/* Botão hamburger para mobile */}
                        <button
                            className="hamburger-btn"
                            onClick={() => setSidebarOpen(!sidebarOpen)}
                        >
                            <FaBars className="mr-2" />
                        </button>
                        <h1>Meu Espaço de Desenvolvimento</h1>
                        <p>Bem-vindo à sua jornada de autoconhecimento e crescimento</p>
                    </div>
                    <div className="header-right">
                        <Link to={'/'} className="notifications">
                            <FaHome />
                        </Link>
                        <div className="notifications">
                            <FaBell className="fas fa-bell" />
                            <span className="badge">{userData.notifications.filter(n => !n.read).length}</span>
                        </div>
                        <div className="user-menu">
                            <div className="user-avatar small">
                                {auth.currentUser.photoURL ? <img src={auth.currentUser.photoURL} className='animate-float' alt='Perfil' /> : <div className="avatar-initials">{getInitials(auth.currentUser.displayName)}</div>}
                            </div>
                        </div>
                    </div>
                </header>

                {/* Overview Section */}
                {activeView === 'overview' && (
                    <div className="overview-container">
                        <div className="metrics-grid">
                            <div className="metric-card">
                                <div className="metric-icon">
                                    <i className="fas fa-medal"></i>
                                </div>
                                <div className="metric-info">
                                    <h3>{userData.modulesCompleted}</h3>
                                    <p>Módulos Completos</p>
                                </div>
                            </div>

                            <div className="metric-card">
                                <div className="metric-icon">
                                    <i className="fas fa-brain"></i>
                                </div>
                                <div className="metric-info">
                                    <h3>{userData.skills.length}</h3>
                                    <p>Habilidades Desenvolvidas</p>
                                </div>
                            </div>

                            <div className="metric-card">
                                <div className="metric-icon">
                                    <i className="fas fa-rocket"></i>
                                </div>
                                <div className="metric-info">
                                    <h3>{userData.recentAchievements.length}</h3>
                                    <p>Conquistas Recentes</p>
                                </div>
                            </div>

                            <div className="metric-card">
                                <div className="metric-icon">
                                    <i className="fas fa-heart"></i>
                                </div>
                                <div className="metric-info">
                                    <h3>{Math.max(...Object.values(userData.emotionalState))}</h3>
                                    <p>Ponto Forte Emocional</p>
                                </div>
                            </div>
                        </div>

                        <div className="dashboard-section">
                            <h2>Meu Progresso nos Módulos</h2>
                            <div className="modules-progress">
                                {userData.learningPath.map(module => (
                                    <div key={module.id} className="module-progress-item">
                                        <div className="module-info">
                                            <h4>{module.name}</h4>
                                            <span>{module.progress}%</span>
                                        </div>
                                        <div className="progress-bar">
                                            <div
                                                className="progress-fill"
                                                style={{ width: `${module.progress}%` }}
                                            ></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="dashboard-section" id="stats-section" ref={statsRef}>
                            <h2>Análise Emocional</h2>
                            <div className="emotional-stats">
                                {Object.entries(userData.emotionalState).map(([key, value]) => (
                                    <div key={key} className="stat-item">
                                        <div className="stat-label">
                                            <span>{key.split('').map((l, i) => i === 0 ? l.toUpperCase() : l).join('')}</span>
                                            <span>{value}%</span>
                                        </div>
                                        <div className="stat-bar">
                                            <div
                                                className="stat-fill"
                                                style={{ width: `${value}%` }}
                                            ></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="stat-insight">
                                <i className="fas fa-lightbulb"></i>
                                <p>Seu maior ponto forte é Empatia! Continue desenvolvendo essa habilidade que é essencial para liderança.</p>
                            </div>
                        </div>

                        <div className="dashboard-section" id="resume-section" ref={resumeRef}>
                            <h2>Currículo Vivo</h2>
                            <div className="live-resume">
                                <div className="resume-header">
                                    <h3>{userData.name}</h3>
                                    <p>{userData.role}</p>
                                </div>

                                <div className="resume-section">
                                    <h4>Habilidades Principais</h4>
                                    <div className="skills-grid">
                                        {userData.skills.map((skill, index) => (
                                            <div key={index} className="skill-tag">
                                                {skill}
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="resume-section">
                                    <h4>Conquistas Recentes</h4>
                                    <ul className="achievements-list">
                                        {userData.recentAchievements.map(achievement => (
                                            <li key={achievement.id}>
                                                <i className="fas fa-trophy"></i>
                                                <div>
                                                    <strong>{achievement.title}</strong>
                                                    <span>{achievement.date}</span>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="resume-actions">
                                    <button className="btn-download">
                                        <i className="fas fa-download"></i> Baixar Currículo
                                    </button>
                                    <button className="btn-share">
                                        <i className="fas fa-share-alt"></i> Compartilhar
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="dashboard-section" id="goals-section" ref={goalsRef}>
                            <h2>Metas e Objetivos</h2>
                            <div className="goals-container">
                                {userData.careerGoals.map((goal, index) => (
                                    <div key={index} className="goal-card">
                                        <div className="goal-icon">
                                            <i className="fas fa-flag"></i>
                                        </div>
                                        <div className="goal-content">
                                            <h4>{goal}</h4>
                                            <div className="goal-progress">
                                                <div className="progress-bar">
                                                    <div
                                                        className="progress-fill"
                                                        style={{ width: `${(index + 1) * 25}%` }}
                                                    ></div>
                                                </div>
                                                <span>{(index + 1) * 25}%</span>
                                            </div>
                                            <button className="btn-action">
                                                Ver plano de ação
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>)}

                {/* Modules View */}
                {activeView === 'modules' && (
                    <div className="modules-container">
                        <h2>Meus Módulos de Desenvolvimento</h2>
                        <div className="modules-grid">
                            {userData.learningPath.map(module => (
                                <div key={module.id} className="module-card">
                                    <div className="module-header">
                                        <div className="module-icon">
                                            <i className="fas fa-book"></i>
                                        </div>
                                        <h3>{module.name}</h3>
                                    </div>
                                    <div className="module-progress">
                                        <div className="progress-label">
                                            <span>Progresso</span>
                                            <span>{module.progress}%</span>
                                        </div>
                                        <div className="progress-bar">
                                            <div
                                                className="progress-fill"
                                                style={{ width: `${module.progress}%` }}
                                            ></div>
                                        </div>
                                    </div>
                                    <div className="module-actions">
                                        <button className="btn-continue">
                                            {module.progress === 100 ? 'Revisar' : 'Continuar'}
                                        </button>
                                        <Link to={'/modulo/1'} className="btn-details">
                                            Detalhes
                                        </Link>
                                    </div>
                                    {module.progress === 100 && (
                                        <div className="module-completed">
                                            <i className="fas fa-check-circle"></i> Completo
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="suggested-modules">
                            <h3>Módulos Sugeridos para Você</h3>
                            <div className="suggestions-grid">

                                {modules?.map(module => (
                                    <div className="suggestion-card">
                                        <div className="suggestion-icon">
                                            <i className="fas fa-users"></i>
                                        </div>
                                        <h4> {module.titulo} </h4>
                                        <p> {module.descricao} </p>
                                        <button className="btn-explore">
                                            Explorar
                                        </button>
                                    </div>
                                ))}
                                <div className="suggestion-card">
                                    <div className="suggestion-icon">
                                        <i className="fas fa-hand-holding-usd"></i>
                                    </div>
                                    <h4>Gestão Financeira Pessoal</h4>
                                    <p>Aprenda a organizar suas finanças e investir no seu futuro.</p>
                                    <button className="btn-explore">
                                        Explorar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Resume View */}
                {activeView === 'resume' && (
                    <div className="resume-container">
                        <h2>Currículo Vivo</h2>
                        <div className="resume-live-preview">
                            <div className="resume-header">
                                <div className="resume-avatar">AS</div>
                                <div>
                                    <h1>{userData.name}</h1>
                                    <h2>{userData.role}</h2>
                                </div>
                            </div>

                            <div className="resume-section">
                                <h3>Resumo Profissional</h3>
                                <p>Desenvolvedora Front-end com foco em React, apaixonada por criar experiências de usuário excepcionais. Comprometida com crescimento contínuo e desenvolvimento de habilidades interpessoais.</p>
                            </div>

                            <div className="resume-section">
                                <h3>Habilidades Técnicas</h3>
                                <div className="skills-category">
                                    <h4>Desenvolvimento</h4>
                                    <div className="skills-list">
                                        <div className="skill-item">
                                            <span>React</span>
                                            <div className="skill-level">
                                                <div className="level-dot active"></div>
                                                <div className="level-dot active"></div>
                                                <div className="level-dot active"></div>
                                                <div className="level-dot active"></div>
                                                <div className="level-dot"></div>
                                            </div>
                                        </div>
                                        <div className="skill-item">
                                            <span>JavaScript</span>
                                            <div className="skill-level">
                                                <div className="level-dot active"></div>
                                                <div className="level-dot active"></div>
                                                <div className="level-dot active"></div>
                                                <div className="level-dot active"></div>
                                                <div className="level-dot"></div>
                                            </div>
                                        </div>
                                        <div className="skill-item">
                                            <span>CSS/SASS</span>
                                            <div className="skill-level">
                                                <div className="level-dot active"></div>
                                                <div className="level-dot active"></div>
                                                <div className="level-dot active"></div>
                                                <div className="level-dot"></div>
                                                <div className="level-dot"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="skills-category">
                                    <h4>Habilidades Interpessoais</h4>
                                    <div className="skills-list">
                                        <div className="skill-item">
                                            <span>Comunicação</span>
                                            <div className="skill-level">
                                                <div className="level-dot active"></div>
                                                <div className="level-dot active"></div>
                                                <div className="level-dot active"></div>
                                                <div className="level-dot active"></div>
                                                <div className="level-dot"></div>
                                            </div>
                                        </div>
                                        <div className="skill-item">
                                            <span>Inteligência Emocional</span>
                                            <div className="skill-level">
                                                <div className="level-dot active"></div>
                                                <div className="level-dot active"></div>
                                                <div className="level-dot active"></div>
                                                <div className="level-dot"></div>
                                                <div className="level-dot"></div>
                                            </div>
                                        </div>
                                        <div className="skill-item">
                                            <span>Gestão de Tempo</span>
                                            <div className="skill-level">
                                                <div className="level-dot active"></div>
                                                <div className="level-dot active"></div>
                                                <div className="level-dot active"></div>
                                                <div className="level-dot active"></div>
                                                <div className="level-dot"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="resume-section">
                                <h3>Conquistas e Certificados</h3>
                                <ul className="achievements-list">
                                    {userData.recentAchievements.map(achievement => (
                                        <li key={achievement.id}>
                                            <i className="fas fa-trophy"></i>
                                            <div>
                                                <strong>{achievement.title}</strong>
                                                <span>{achievement.date}</span>
                                            </div>
                                        </li>
                                    ))}
                                    <li>
                                        <i className="fas fa-trophy"></i>
                                        <div>
                                            <strong>Certificado em React Avançado</strong>
                                            <span>10/04/2023</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="resume-actions">
                            <button className="btn-download">
                                <i className="fas fa-download"></i> Baixar PDF
                            </button>
                            <button className="btn-customize">
                                <i className="fas fa-paint-brush"></i> Personalizar Design
                            </button>
                            <button className="btn-share">
                                <i className="fas fa-share-alt"></i> Compartilhar
                            </button>
                        </div>
                    </div>
                )}

                {/* Skill Builder View */}
                {activeView === 'skillBuilder' && (
                    <div className="skill-builder-container">
                        <h2>Construtor de Habilidades</h2>
                        <p>Desenvolva qualquer habilidade de forma assistida e personalizada</p>
                        <SkillBuilder />
                    </div>
                )}
            </div>

            {/* Gama Assistant */}
            <GamaAssistant
                active={assistantActive}
                messages={assistantMessages}
                onToggle={toggleAssistant}
                onSendMessage={addAssistantMessage}
            />
        </div>
    );
};

export default Dashboard;